module.exports = __webpack_public_path__ + "img/icons_11.62a53f38.png";